import Vue from "vue";
import axios from "axios";

export default {
    namespaced: true,
    state: {
        // first_name: "",
        // last_name: "",
        // email: "",
        // username: "",
        isAdmin: false,
        isSet: false
    },
    mutations: {
        setAccessData(state, data) {
            let base64Url = data.split('.')[1];
            let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            let json = JSON.parse(jsonPayload);
            for (let [key, value] of Object.entries(json)) {
                state[key] = value;
            }
            state.isAdmin = !!json.admin; // !! is used to turn a truthy/falsy value into an actual boolean
            state.isSet = true;
        },
        setUserData(state, data) {
            for (let [key, value] of Object.entries(data)) {
                state[key] = value;
            }
        },
        setUserId(state, id) {
            state.userId = id;
        },
        async finishInit(state) {
            state.isSet = true;
        }
    },
    getters: {
        isSet(state) {
            return state.isSet;
        },
        isAdmin(state) {
            return state.isAdmin;
        },
        getItem: (state) => async (key) => { // You have to return a function in order to pass arguments to a getter
            if (await Vue.prototype.$auth.isAuthenticated()) {
                return state[key];
            }
        }
    },
    actions: {
        async initUser({commit, getters, rootState, rootGetters}) {
            if (await Vue.prototype.$auth.isAuthenticated()) {
                let accessToken = await Vue.prototype.$auth.getAccessToken();
                commit('setAccessData', accessToken);
                let userData = await Vue.prototype.$auth.getUser();
                commit('setUserData', userData);
                let userId = await axios.get(rootGetters["server"] + "/get-user-id", {params: {email: await getters["getItem"]("preferred_username")}});
                if (userId.data.object.user_id === null) {
                    userId = await axios.get(rootGetters["server"] + "/create-user", {params: {
                        email: await getters["getItem"]("preferred_username"),
                        first_name: await getters["getItem"]("first_name"),
                        last_name: await getters["getItem"]("last_name")
                    }});
                }
                commit('setUserId', userId.data.object.user_id);
                commit('finishInit');
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js